import { useCallback } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { useStoreValue } from '../../state/hooks/useStore';

export type UseSendDataDogCustomResult = (params: {
  eventType: string;
  success?: boolean;
  data?: Record<string, unknown>;
  error?: Error;
}) => void;

export function useSendDataDogCustomEvent() {
  const store = useStoreValue();

  return useCallback<UseSendDataDogCustomResult>(
    ({ eventType, error, success, data }) => {
      datadogRum.addAction(eventType, {
        store,
        errorMessage: error?.message,
        success,
        ...data
      });
    },
    [store]
  );
}
